module.exports = __webpack_public_path__ + "static/media/sort-amount-up.2987158e.svg";